import * as React from 'react';
import { Route } from 'react-router-dom';

import DictionaryGrid from '@modules/dictionary/DictionaryGrid';

const View: React.SFC<any> = ({ match }) => {
  return (
    <div>
      <Route path={`${match.url}/:dictionary`} component={DictionaryGrid} />
    </div>
  );
};

export const Dictionary = View;



// WEBPACK FOOTER //
// ./src/modules/dictionary/Dictionary.tsx